import { FUNDING_GROUP_EXCHANGES } from '@/utils/consts'
import type { FundingRateGroupResponse } from '@/services/funding-rates-v2-service/types'
import type { TableColumn } from '@/components/alerts/types'
import { getTradeUrl } from '@/utils'

export const getFundingRateGroupsTableColumns = (): TableColumn[] => {
  const result: TableColumn[] = [
    {
      field: 'symbol.name',
      width: '120px',
      header: 'table.asset',
      class: 'text-center border-b-0 text-sm',
      inner: 'span',
      innerProps: {
        class: 'pit',
      },
    },
  ]
  for (const ex of FUNDING_GROUP_EXCHANGES) {
    result.push(
      {
        dynamic: true,
        field: `${ex}_rate`,
        width: '100px',
        header: `exchangeTitle.${ex}`,
        class: 'text-right border-b-0 border-l-1 border-color-2',
        inner: 'a',
        innerPropsGenerator: (v: object) => {
          const data = v as FundingRateGroupResponse
          return {
            target: '_blank',
            href: getTradeUrl(ex, data.symbol.name.split('/')[0] ?? 'BTC', true),
            class: 'pit success hover',
          }
        },
      },
      {
        field: `${ex}_period`,
        width: '80px',
        header: '',
        class: 'text-left border-b-0',
        inner: 'span',
        innerProps: {
          class: 'pit success',
        },
      },
    )
  }
  return result
}
